import React, {Component} from 'react';
import {FaSignOutAlt, FaUser} from 'react-icons/fa';

class UserIdentity extends Component {
  constructor(props){
    super(props);

    this.handleLogoutClick = this.handleLogoutClick.bind(this);
  }

  componentWillReceiveProps(newProps){
    if(this.props === newProps) { return };
    this.props = newProps;
  }

  handleLogoutClick(e) {
    //redirect to logout route
    window.location.href ='/auth/logout';
  }

  render(){
    return (
      <div>
        {(this.props.isAuthenticated === true) && (
          <div className="identity">
            <button title="Logout" onClick={this.handleLogoutClick} className="btn-identity-logout"><FaSignOutAlt/></button>
            <div className="identity-user">
              <div className="identity-user-icon"><FaUser/></div>
              John Doe
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default UserIdentity;
